import { authHeader } from '../../_helpers';
import axios from 'axios';

export const lndSevice = {
    getLnData,
}

axios.defaults.headers.common = authHeader();
let token = localStorage.getItem('access_token')


function getLnData(data) {
    return axios.post(`/analytics/analytics_organisation/team/analyse/learning_and_development/?access_token=${token}`,data)
        .then(response => {
            return response;
        });
}


// WEBPACK FOOTER //
// ./src/_services/Analyze/lnd.service.js